/**
 * Get auth token from localStorage
 */
export function getToken(): string | null {
  return localStorage.getItem('authToken');
}

/**
 * Extract user profile information from JWT token
 */
export async function getUserProfile(accessToken?: string): Promise<{ fullName: string | null; email: string | null;  jobTitle: string | null; persona: string | null; } | null> {

  try {

    const token = accessToken || getToken();
    if (!token){
      console.error('Auth token is null when attempting to fetch user profile', token);
      return null;
    } 

    const response = await getProfileFromDatabase(token);

    if (!response) {
      console.error('getProfileFromDatabase returned null');
      return null;
    }

    // API returns an array; extract first element
    const profileData = Array.isArray(response) ? response[0] : response;

    return {
      fullName: (profileData.firstName && profileData.surname)
        ? `${profileData.firstName} ${profileData.surname}`
        : null,
      email: profileData.emailAddress || null,
      jobTitle: profileData.jobTitle || null,
      persona: profileData.persona || null,
    };
  } catch (err) {
    console.error('Failed to fetch user profile:', err);
    return null;
  }
}


const getProfileFromDatabase = async (userToken: string) => {
  try {
    const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5123';
    const response = await fetch(`${apiUrl}/fabric/get-profile-data`, {
      headers: {
        'Authorization': `Bearer ${userToken}`
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}: ${response.statusText}`);
    }

    const profileData = await response.json();
    console.log('[GetUserprofile] User profile retrieved:', profileData);
    return profileData;
  } 
  catch (err: any) {
    const errorMsg = err.message || 'Failed to pull user profile';
    console.error('[GetUserprofile] Pull user profile error:', errorMsg);
    return null;
  } 
};

